package com.milta.feature.spreadsheetimport.domain.usecase

import com.milta.feature.spreadsheetimport.domain.entity.SpreadsheetImportResult
import com.milta.feature.spreadsheetimport.domain.repository.SpreadsheetImportRepository

/** POST /api/v1/spreadsheet-imports — écran B du mockup MIL-27. */
class ImportSpreadsheetUseCase(private val repository: SpreadsheetImportRepository) {
    suspend operator fun invoke(fileBytes: ByteArray, fileName: String): SpreadsheetImportResult =
        repository.importSpreadsheet(fileBytes, fileName)
}
